module.exports = __webpack_public_path__ + "static/img/14.d9a819d3.jpg";